import React from 'react';

function GeneralProgram() {
  return (
    <div className='product-area section-bottom-padding bg-white"'>
      <div className='container'>
        <div className='row'>
          <div className='col-md-12'>
            <div className='section-title-wrapper'>
              <div className='section-title'>
                <h3>PROGRAMA GENERAL</h3>
                <br />
              </div>
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='col-md-12'>
            <div className='single-event-item'>
              <div className='single-event-text'>
                <h5 style={{ textAlign: 'center', paddingBottom: '4px' }}>
                  JUEVES 25 DE AGOSTO
                </h5>
                <div
                  className='row '
                  style={{
                    borderTop: '1px solid  rgba(208, 211, 212 )',
                    paddingTop: '10px',
                  }}
                >
                  <div
                    className='col-md-2'
                    style={{
                      borderRight: '1px solid rgba(208, 211, 212 )',
                      textAlign: 'center',
                    }}
                  >
                    <h6 style={{ paddingTop: '12px', paddingBottom: '18px' }}>
                      Hora GMT-7
                    </h6>
                    <time>9:30</time>
                    <br />
                    <br />
                    <hr />
                    <time>10:00</time>
                    <br />
                    <br />
                    <hr />
                    <br />
                    <br />
                    <time>11:00</time>
                    <br />
                    <br />
                    <br />
                    <hr style={{ marginTop: '25px' }} />
                    <br />
                    <br />
                    <time>15:00</time>
                  </div>
                  <div
                    className='col-md-3'
                    style={{
                      borderRight: '1px solid rgba(208, 211, 212 )',
                      textAlign: 'center',
                    }}
                  >
                    <h6 style={{ paddingTop: '12px', paddingBottom: '18px' }}>
                      Programa
                    </h6>
                    Acto inaugural <br />
                    <br />
                    <hr />
                    Conferencia magistral, Dale Johnson
                    <br />
                    <br />
                    <hr />
                    Webinar EMPROVE, Alfredo González
                    <br />
                    <hr />
                    Webinar EDILAR, Sagrario Rodríguez e Israel Vázquez
                    <hr />
                    Webinar CRESON, Adriana Carrillo
                    <hr style={{ marginTop: '35px' }} />
                    Webinar TEC DE MONTERREY, Leonardo Glasserman
                  </div>
                  <div
                    className='col-md-3'
                    style={{
                      borderRight: '1px solid rgba(208, 211, 212 )',
                    }}
                  >
                    <h6
                      style={{
                        paddingTop: '12px',
                        paddingBottom: '15px',
                        textAlign: 'center',
                      }}
                    >
                      Tema
                    </h6>
                    Autoridades Educativas
                    <br />
                    <br />
                    <hr />
                    Aprendizaje adaptativo: transformación para la eseñanza
                    <hr />
                    Creando actividades interactivas en MOODLE con H5P
                    <hr />
                    Crea clases innovadoras con Goggle workspace for Education
                    <hr />
                    Realidad aumentada: explora tu imaginación
                    <hr />
                    Credenciales alternativas: tecnologías que pueden cambiar
                    las formación del futuro
                  </div>
                  <div
                    className='col-md-2'
                    style={{
                      textAlign: 'center',
                      borderRight: '1px solid rgba(208, 211, 212 )',
                    }}
                  >
                    <h6 style={{ paddingTop: '12px', paddingBottom: '5px' }}>
                      Ligas
                    </h6>

                    <a
                      href='https://us02web.zoom.us/j/87570742259?pwd=SjVzTTREQXFoTXFSaDg5NGVhT3Jodz09'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Enlace ZOOM A
                    </a>
                    <br />
                    <a
                      href='https://us02web.zoom.us/j/88486978752?pwd=UFMzd3VLNlBRcEdLbEZRK1c0cUVFZz09'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Enlace ZOOM B
                    </a>
                    <br />
                    <a
                      href='https://us02web.zoom.us/j/83791755562?pwd=ZFUrUzhVeUIrazB3alRaNk5yN3gydz09'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Enlace ZOOM C
                    </a>
                    <hr style={{ marginTop: '5px', marginBottom: '2px' }} />

                    <a
                      href='https://us02web.zoom.us/j/87570742259?pwd=SjVzTTREQXFoTXFSaDg5NGVhT3Jodz09'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Enlace ZOOM A
                    </a>
                    <br />
                    <a
                      href='https://us02web.zoom.us/j/88486978752?pwd=UFMzd3VLNlBRcEdLbEZRK1c0cUVFZz09'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Enlace ZOOM B
                    </a>
                    <br />
                    <a
                      href='https://us02web.zoom.us/j/83791755562?pwd=ZFUrUzhVeUIrazB3alRaNk5yN3gydz09'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Enlace ZOOM C
                    </a>
                    <hr style={{ marginTop: '7px', marginBottom: '25px' }} />
                    <a
                      href='https://us02web.zoom.us/j/87570742259?pwd=SjVzTTREQXFoTXFSaDg5NGVhT3Jodz09'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Enlace ZOOM A
                    </a>
                    <hr style={{ marginTop: '30px' }} />
                    <a
                      href='https://us02web.zoom.us/j/88486978752?pwd=UFMzd3VLNlBRcEdLbEZRK1c0cUVFZz09'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Enlace ZOOM B
                    </a>
                    <hr style={{ marginTop: '35px' }} />
                    <a
                      href='https://us02web.zoom.us/j/87570742259?pwd=SjVzTTREQXFoTXFSaDg5NGVhT3Jodz09'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Enlace ZOOM A
                    </a>
                    <hr style={{ marginTop: '41px' }} />
                    <a
                      href='https://us02web.zoom.us/j/88486978752?pwd=UFMzd3VLNlBRcEdLbEZRK1c0cUVFZz09'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Enlace ZOOM B
                    </a>
                  </div>
                  <div
                    className='col-md-2'
                    style={{
                      //borderRight: "1px solid rgba(208, 211, 212 )",
                      textAlign: 'center',
                    }}
                  >
                    <h6 style={{ paddingTop: '12px' }}>Facebook Video</h6>
                    <div className='logo' style={{ paddingTop: '20px' }}>
                      <a
                        href='https://www.facebook.com/cresonsonora/videos'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <img
                          src='/img/facebook.png'
                          style={{ width: '30px' }}
                          alt='1er Foro'
                        />
                      </a>
                    </div>

                    <hr style={{ marginTop: '25px' }} />
                    <div className='logo' style={{ paddingTop: '3px' }}>
                      <a
                        href='https://www.facebook.com/cresonsonora/videos'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <img
                          src='/img/facebook.png'
                          style={{ width: '30px' }}
                          alt='1er Foro'
                        />
                      </a>
                    </div>
                    <hr style={{ marginTop: '25px' }} />

                    <div className='logo' style={{ paddingTop: '3px' }}>
                      <a
                        href='https://www.facebook.com/cresonsonora/videos'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <img
                          src='/img/facebook.png'
                          style={{ width: '30px' }}
                          alt='1er Foro'
                        />
                      </a>
                    </div>
                    <hr style={{ marginTop: '30px' }} />
                    <div className='logo' style={{ paddingTop: '3px' }}>
                      <a
                        href='https://www.facebook.com/cresonsonora/videos'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <img
                          src='/img/facebook.png'
                          style={{ width: '30px' }}
                          alt='1er Foro'
                        />
                      </a>
                    </div>
                    <hr style={{ marginTop: '24px' }} />
                    <div className='logo' style={{ paddingTop: '1px' }}>
                      <a
                        href='https://www.facebook.com/cresonsonora/videos'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <img
                          src='/img/facebook.png'
                          style={{ width: '30px' }}
                          alt='1er Foro'
                        />
                      </a>
                    </div>
                    <hr style={{ marginTop: '32px' }} />
                    <div className='logo' style={{ paddingTop: '1px' }}>
                      <a
                        href='https://www.facebook.com/cresonsonora/videos'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <img
                          src='/img/facebook.png'
                          style={{ width: '30px' }}
                          alt='1er Foro'
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
        <div className='row'>
          <div className='col-md-12'>
            <div className='single-event-item'>
              <div className='single-event-text'>
                <h5 style={{ textAlign: 'center', paddingBottom: '4px' }}>
                  VIERNES 26 DE AGOSTO
                </h5>
                <div
                  className='row '
                  style={{
                    borderTop: '1px solid  rgba(208, 211, 212 )',
                    paddingTop: '10px',
                  }}
                >
                  <div
                    className='col-md-2'
                    style={{
                      borderRight: '1px solid rgba(208, 211, 212 )',
                      textAlign: 'center',
                    }}
                  >
                    <h6 style={{ paddingTop: '12px', paddingBottom: '18px' }}>
                      Hora
                    </h6>
                    <time>10:00</time>
                    <br />
                    <br />
                    <br />
                    <br />
                    <hr />

                    <br />
                    <br />
                    <time>11:00</time>
                  </div>
                  <div
                    className='col-md-3'
                    style={{
                      borderRight: '1px solid rgba(208, 211, 212 )',
                      textAlign: 'center',
                    }}
                  >
                    <h6 style={{ paddingTop: '12px', paddingBottom: '18px' }}>
                      Programa
                    </h6>
                    <br />
                    Conferencia magistral
                    <br />
                    <br />
                    <br />
                    <hr />
                    Webinar ROBOTIX, Roberto Saint Martin
                    <br />
                    <hr />
                    Webinar INTELLIBOARD, Samuel de Jesús
                  </div>
                  <div
                    className='col-md-3'
                    style={{
                      borderRight: '1px solid rgba(208, 211, 212 )',
                    }}
                  >
                    <h6
                      style={{
                        paddingTop: '12px',
                        paddingBottom: '15px',
                        textAlign: 'center',
                      }}
                    >
                      Tema
                    </h6>
                    Efecto de una plataforma inmersiva en el aprendizaje de
                    ciencias y en el desarrollo de habilidades socioafectivas en
                    estudiantes K-12
                    <hr />
                    Robótica educativa y STEAM en la creatividad de la niñez
                    <hr />
                    ¿Cómo crear programas de intervención efectivos basados en
                    la analítica de datos?
                  </div>
                  <div
                    className='col-md-2'
                    style={{
                      borderRight: '1px solid rgba(208, 211, 212 )',
                      textAlign: 'center',
                    }}
                  >
                    <h6 style={{ paddingTop: '12px', paddingBottom: '15px' }}>
                      Ligas
                    </h6>

                    <a
                      href='https://us02web.zoom.us/j/87570742259?pwd=SjVzTTREQXFoTXFSaDg5NGVhT3Jodz09'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Enlace ZOOM A
                    </a>
                    <br />
                    <a
                      href='https://us02web.zoom.us/j/88486978752?pwd=UFMzd3VLNlBRcEdLbEZRK1c0cUVFZz09'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Enlace ZOOM B
                    </a>
                    <br />
                    <a
                      href='https://us02web.zoom.us/j/83791755562?pwd=ZFUrUzhVeUIrazB3alRaNk5yN3gydz09'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Enlace ZOOM C
                    </a>
                    <hr style={{ marginTop: '35px' }} />
                    <br />
                    <a
                      href='https://us02web.zoom.us/j/87570742259?pwd=SjVzTTREQXFoTXFSaDg5NGVhT3Jodz09'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Enlace ZOOM A
                    </a>
                    <hr style={{ marginTop: '20px' }} />
                    <a
                      href='https://us02web.zoom.us/j/88486978752?pwd=UFMzd3VLNlBRcEdLbEZRK1c0cUVFZz09'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Enlace ZOOM B
                    </a>
                  </div>
                  <div className='col-md-2' style={{ textAlign: 'center' }}>
                    <h6 style={{ paddingTop: '12px' }}>Facebook Video</h6>
                    <div className='logo' style={{ paddingTop: '35px' }}>
                      <a
                        href='https://www.facebook.com/cresonsonora/videos'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <img
                          src='/img/facebook.png'
                          style={{ width: '30px' }}
                          alt='1er Foro'
                        />
                      </a>
                      <hr style={{ marginTop: '49px' }} />
                    </div>
                    <div className='logo' style={{ paddingTop: '12px' }}>
                      <a
                        href='https://www.facebook.com/cresonsonora/videos'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <img
                          src='/img/facebook.png'
                          style={{ width: '30px' }}
                          alt='1er Foro'
                        />
                      </a>
                      <hr style={{ marginTop: '23px' }} />
                    </div>
                    <div className='logo' style={{ paddingTop: '12px' }}>
                      <a
                        href='https://www.facebook.com/cresonsonora/videos'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <img
                          src='/img/facebook.png'
                          style={{ width: '30px' }}
                          alt='1er Foro'
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GeneralProgram;
